var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.actual)?_c('span',[_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.actual))+" ")]):_c('span',{staticClass:"expected"},[_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.expected))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }